import { emptyNamed, emptyTerm, formulaTree } from '../CalculationBuilder';

function uid() {
  return Math.random().toString(36).slice(2, 10);
}

export function formulaToChain(node) {
  const terms = [];
  const operators = [];
  const appendLeaf = (current) => {
    if (current && (current.ref === 'input' || current.ref === 'parameter' || current.ref === 'named')) {
      terms.push({ kind: current.ref, key: current.key || '', value: '' });
      return;
    }
    if (current && Object.prototype.hasOwnProperty.call(current, 'const')) {
      terms.push({ kind: 'constant', key: '', value: String(current.const) });
      return;
    }
    terms.push(emptyTerm());
  };
  const walk = (current) => {
    if (current && current.op && Array.isArray(current.args) && current.args.length === 2) {
      walk(current.args[0]);
      operators.push(current.op);
      appendLeaf(current.args[1]);
      return;
    }
    appendLeaf(current);
  };
  if (!node) return { terms: [emptyTerm()], operators: [] };
  walk(node);
  if (!terms.length) terms.push(emptyTerm());
  return { terms, operators };
}

export function stateFromDocument(document) {
  const parameters = (document?.parameters || []).map((row) => ({
    id: uid(),
    key: row.key,
    label: row.label || row.key,
    description: row.description || '',
    required: row.required !== false,
    defaultValue: row.default_value == null ? '' : String(row.default_value),
    display: row.display || 'number',
  }));
  const namedValues = (document?.named_values || []).map((row) => ({
    id: uid(),
    key: row.key,
    label: row.label || row.key,
    ...formulaToChain(row.formula),
  }));
  return {
    parameters,
    namedValues: namedValues.length ? namedValues : [emptyNamed()],
    calculationType: document?.calculation_type === 'cumulative' ? 'cumulative' : 'periodic',
  };
}

export function destinationState(document) {
  const row = document?.destination;
  if (!row?.cost_code_vuid) return null;
  return {
    destination_cost_code_vuid: row.cost_code_vuid,
    destination_cost_type_vuid: row.cost_type_vuid || '',
    destination_cost_code_label: row.cost_code_label || '',
    destination_cost_type_label: row.cost_type_label || '',
  };
}

export function documentFromState(parameters, namedValues, source, destination, calculationType) {
  const document = {
    parameters: parameters.filter((row) => row.key && row.label).map((row) => ({
      key: row.key,
      label: row.label,
      value_type: 'decimal',
      required: row.required !== false,
      description: row.description || '',
      default_value: row.defaultValue === '' || row.defaultValue == null ? null : String(row.defaultValue),
      display: row.display || 'number',
    })),
    named_values: namedValues.filter((row) => row.key && row.label).map((row) => ({
      key: row.key,
      label: row.label,
      formula: formulaTree(row),
    })),
  };
  if (source?.cost_type_vuid) {
    document.source = {
      cost_type_vuid: source.cost_type_vuid,
      cost_type_label: source.cost_type_label || '',
    };
  }
  const code = destination?.destination_cost_code_vuid || destination?.cost_code_vuid;
  if (code) {
    document.destination = {
      cost_code_vuid: code,
      cost_type_vuid: destination.destination_cost_type_vuid || destination.cost_type_vuid || '',
      cost_code_label: destination.destination_cost_code_label || destination.cost_code_label || '',
      cost_type_label: destination.destination_cost_type_label || destination.cost_type_label || '',
    };
  }
  if (calculationType === 'cumulative' || calculationType === 'periodic') {
    document.calculation_type = calculationType;
  }
  return document;
}

export const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

export function periodLabel(period) {
  if (!period) return '';
  const month = MONTHS[(Number(period.month) || 1) - 1] || '';
  return `${month} ${period.year || ''}`.trim();
}
